import { paddingBottom } from '@sleepstation/style-api-helpers'
import PropTypes from 'prop-types'
import React from 'react'
import styled from 'styled-components'

// -----------------------------------------------------------------------------
// Sub-components
// -----------------------------------------------------------------------------

const Layout = styled.div`
  position: relative;
  ${paddingBottom(2)}
`

const Inner = styled.div`
  margin: 0 auto;
  width: 100%;
`

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const OptionsFullWidthBreakoutModule = ({ children }) => (
  <Layout className="breakout">
    <Inner>{children}</Inner>
  </Layout>
)

OptionsFullWidthBreakoutModule.propTypes = {
  children: PropTypes.node.isRequired,
}

export default OptionsFullWidthBreakoutModule
